import Settings from '../../../services/settings'
import Tenant from '../../../services/tenant'

const fetch = async (context) => {
  return new Promise((resolve, reject) => {
    Settings.fetch()
      .then((response) => {
        resolve(response.data)
      })
      .catch((error) => {
        reject(error)
      })
  })
}

const save = ({ commit }, payload) => {
  return new Promise((resolve, reject) => {
    Settings.save(payload).then((response) => {
      commit('SET_SYSTEM_SETTINGS', response.data)
      resolve(response.data)
    })
    .catch((error) => {
      reject(error)
    })
  })
}

const fetchBank = async (context) => {
  return new Promise((resolve, reject) => {
    Settings.bankAccount()
      .then((response) => {
        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  })
}

const loadSystemSettings = async ({ commit }) => {
  return new Promise((resolve, reject) => {
    Settings.load()
      .then((response) => {
        commit('SET_SYSTEM_SETTINGS', response.data)
        resolve(response.data)
      })
      .catch((error) => {
        reject(error)
      })
  })
}

const resetTenant = async ({ commit }, payload) => {
  return new Promise((resolve, reject) => {
    Tenant.reset(payload).then((response) => {
      resolve(response.data)
    }).catch((error) => {
      reject(error)
    })
  })
}

const updateValues = ({ commit }, obj) => {
  commit('SET_SYSTEM_SETTINGS', obj)
}

export default {
  fetch,
  save,
  fetchBank,
  loadSystemSettings,
  updateValues,
  resetTenant
}



// WEBPACK FOOTER //
// ./src/features/settings/store/actions.js